import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { first } from 'rxjs';
import { ApiServiceService } from 'src/app/_service/api-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import * as $ from 'jquery';
import { TimeScale } from 'chart.js';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-mentor',
  templateUrl: './mentor.component.html',
  styleUrls: ['./mentor.component.scss'],
})
export class MentorComponent implements OnInit {
  district_list: any[] = this.ApiService.all_districts;
  countries: any[] = this.ApiService.country;

  users: any;
  //= JSON.parse(localStorage.getItem('login_user_details'));
  district: any;
  constituency: string = '';
  OBConstituency: string;
  user_constituency: any = this.ApiService.all_constituency['Chennai North'];
  assigned_to: any;
  zones: any = this.ApiService.zones;
  user_name: any;
  //= this.ApiService.user_details.firstname;
  user_id: any;
  // =this.ApiService.user_details.id;
  activity_type: any;
  activity_date: any;
  activity_time: any;
  activity: string = 'Select Activity';
  description: any;
  status: any;
  others: any;
  customers: any = [];
  summary_activity: any = [];
  MeetingOptions: any;
  participantsptions: any;
  // districts:any=['Salem','Karur','Namakkal','Trichy'];
  createmeetingform!: FormGroup;
  constituencies!: any;
  meeting_name: any;
  meeting_time: any;
  meeting_date: any;
  participants: any;
  meeting_type: any;
  meeting_location: any;
  spinner: boolean;
  hidden: boolean = true;
  dropdownList: string[] = [];
  dropdownSettings: IDropdownSettings = {};
  add = [];
  name: any;
  last_name: any;
  DOB: any;
  education: any;
  email: any;
  number: any;
  parent_number: any;
  branch: any;
  area: any;
  courses: any;
  grade: any;
  college_name: any;
  subject: any;
  uploadFiles: any = '';
  list_courses: any = [];
  password: any = '';
  confirm_password: any = '';
  password_wrong: any = false;
  available: any = false;

  selectedItems = [];

  dropDownForm: FormGroup;
  tableshow: boolean = false;
  editmeetingform!: FormGroup;
  CM_id: any;
  CM_zone: any;
  whatsappLabel: string = 'WhatsApp Number (User ID)'; // Default label
  countryCode: string = '+91'; 
  getChangeAssignedTo(assigned_to: any) {
    if (assigned_to === 'District') {
      $('#Check1').css('display', 'flex');
    } else {
      $('#Check1').css('display', 'none');
    }
    if (assigned_to === 'Zone') {
      $('#zones').css('display', 'block');
    } else {
      $('#zones').css('display', 'none');
    }
  }

  // getChangeToConstituey(value: any) {
  //   this.user_constituency = this.ApiService.all_constituency[value];
  //   this.ApiService.datablelogin(value).subscribe((data: any) => {
  //     let obj = data;
  //     this.customers = obj.data;
  //   });
  // }

  handleActivityTypeChange(value: any) {
    if (value === 'Others') {
      $('#others').css('display', 'block');
    } else {
      $('#others').css('display', 'none');
    }
  }

  // handleRadioClick(value: any) {
  //   const numberControl = this.createmeetingform.get('number');
  //   if (value !== 'Normal') {
  //     this.whatsappLabel = 'WhatsApp Number With Country Code (User ID)';
  //     this.available = true;
  //     numberControl.setValidators([
  //       Validators.required,
  //       Validators.pattern('^\\+[0-9]{1,15}$')
  //     ]);
  //     this.setValidatorsForAvailableControls();
  //   } else{
  //     this.whatsappLabel = 'WhatsApp Number (User ID)';
  //     this.available = false;
  //     numberControl.setValidators([
  //       Validators.required,
        
  //     ]);
  //     this.resetValidatorsForAvailableControls();
  //   }  
  //    // Update the form control validity
  // numberControl.updateValueAndValidity();  
  // }

 
  handleRadioClick(value: any) {
    const numberControl = this.createmeetingform.get('number');
    if (value !== 'Normal') { // Non-Resident selected
      this.whatsappLabel = 'WhatsApp Number With Country Code (User ID)';
      this.countryCode = '';
      this.available = true;
      numberControl.setValidators([
        Validators.required,
        Validators.pattern('^[0-9]{1,15}$') // Allows only numbers from 1 to 15 digits
      ]);
      this.setValidatorsForAvailableControls();
    } else { // Resident selected
      this.countryCode = '+91';
      this.whatsappLabel = 'WhatsApp Number (User ID)';
      this.available = false;
      numberControl.setValidators([
        Validators.required,
        Validators.pattern('^[0-9]{10}$')
      ]);
      this.resetValidatorsForAvailableControls();
    }
    numberControl.updateValueAndValidity();
  }

  setValidatorsForAvailableControls() {
    this.createmeetingform.get('country')?.setValidators(Validators.required);
    this.updateValidators(['country']);
  }

  resetValidatorsForAvailableControls() {
    this.createmeetingform.get('country')?.clearValidators();
    this.updateValidators(['country']);
  }

  updateValidators(controlNames: string[]) {
    controlNames.forEach((controlName) => {
      const control = this.createmeetingform.get(controlName);
      if (control) {
        control.updateValueAndValidity();
      }
    });
  }

  handleDeleteClick(id: any) {
    $(`#adding_${id}`).remove();
  }

  constructor(
    private fb: FormBuilder,
    private ApiService: ApiServiceService,
    private router: Router,
    private spinnerService: NgxSpinnerService,
    public datepipe: DatePipe,
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) {
    this.createmeetingform = this.fb.group({
      first_name: ['',[Validators.required, Validators.pattern('[A-Za-z ]{1,32}')]],
      last_name: [
        '',
        [Validators.required, Validators.pattern('[A-Za-z ]{1,32}')],
      ],
      education: ['', [Validators.required,Validators.pattern(/^[A-Za-z!@#^&()_+\-=:;'|<>,.?\/\s]+$/)]],
      // education: ['', [Validators.required, Validators.pattern(/^[A-Za-z'|<>,.\/\\s]{1,32}$/)]],
      branch: ['Select Branch', Validators.required],
     // constituency: ['', Validators.required],
      email: [
        '',
        [
          Validators.required,
          Validators.email,
          Validators.pattern(
            '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$'
          ),
        ],
      ],
      countryCode:['+91'],
      number: [''],
      area: ['', [Validators.required, Validators.pattern(/^[A-Za-z0-9!@#^&()_+\-=:;'|<>,.?\/\s]{1,32}$/)]],
      //courses: ['', Validators.required],
      district: ['', Validators.required],
      //activity: ['Select Activity', Validators.required],

      // status: ['', Validators.required],
      // image: ['', [this.imageSizeValidator(60000)]],
      country: [''],

       // Limit image size to 60 KB
      // available_days: [''],
      // available_from_date: [this.getCurrentDate(),Validators.required],
      // available_to_date: [this.getCurrentDate(),Validators.required],
      password:  ['',[ Validators.required,this.passwordValidator()]],
      confirm_password: ['', Validators.required]
    }, { validator: this.passwordMatchValidator });
    this.editformInitialize('false');
    this.handleRadioClick('Normal');
  }

  dtOptions: DataTables.Settings = {};
  date: any;
  ngOnInit(): void {
    this.date = new Date();
    // document.write(today);
    this.customers = [];
    this.showSpinner();
   
    this.ApiService.getMentorsList().subscribe((data: any) => {
      this.customers = data;
      this.tableshow = true;
    });

    this.ApiService.getCourses().subscribe((data: any) => {
      this.dropdownList = data.map((res) => res.course_name);
    });

    this.dtOptions = {
      pagingType: 'full_numbers',
    };

    this.selectedItems = [{}];
    this.dropDownForm = this.fb.group({
      courses: [this.selectedItems],
    });
  }


  captchaError: boolean = false;
  recaptchaToken: string | null = null;
  captchaResolved: boolean = false;

  onCaptchaResolved(response: string) {
    if (response) {
      this.recaptchaToken = response;
      this.captchaError = false;
      this.captchaResolved = true;
     // console.log(Resolved captcha with response: ${response});
    } else {
      this.captchaResolved = false;

      this.captchaError = true;

    }
  }
  //Default date time in form
  current_date: any;
  current_time:any;
  setCurrentdate() {
    this.current_date = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    this.current_time = this.datepipe.transform(new Date(), 'HH:mm');
    this.createmeetingform.get('activity_date').setValue(this.getCurrentDate());
    this.createmeetingform.get('activity_time').setValue(this.current_time);
  }
  public showSpinner(): void {
    this.spinnerService.show();
  }

  getdata() {
    this.customers = [];
    for (const prop in this.ApiService.tabledatameeting) {
      this.customers.push(this.ApiService.tabledatameeting[prop]);
    }
    this.customers.pop();

    //this.ApiService.viewtableOB();
  }

  test_ph = 'false';
  getphone(c) {
    if (this.createmeetingform.get('number').status == 'VALID') {
      this.ApiService.mentor_ph_check(c).subscribe((data) => {
        console.log(data)
      
        if(data == false) {
         console.log()
          this.test_ph = 'true';
          
      
        } else {
          this.test_ph = 'false';
        }
      });
    }
  }
  test_email = 'false';

  getemail(a) {
    if (this.createmeetingform.get('email').status == 'VALID') {
      this.ApiService.email_check_student(a).subscribe((data) => {
      
        if(data== false) {
         
          this.test_email = 'true';
         

          
        } else {
          this.test_email = 'false';
        }
      
      });
    }
  }

  selectFiles(event: any) {
    if (event.target.files[0].size < 60000) {
      const formData: FormData = new FormData();
      formData.append('file', event.target.files[0]);
      this.ApiService.uploadActivityFile(formData).subscribe((da: any) => {
        this.uploadFiles = da;
      });
    } else {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: "The size should be less than 60kb",
        showConfirmButton: false,
        timer: 1500
      });
      $('#file').val('');
      
      // Mark the 'image' form control as invalid
      this.createmeetingform.get('image')?.setErrors({ 'imageSizeExceeded': true });
    }
  }
  
  
  imageSizeValidator(maxSize: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (control.value && control.value.size) {
        const fileSize = control.value.size; // Get the size of the file
        if (fileSize > maxSize) {
          return { 'imageSizeExceeded': true }; // Return an error if the size exceeds the limit
        }
      }
      return null; // Return null if the size is within the limit
    };
  }
  handleClickNavigate(id: any) {
    this.router.navigate(['activity-summary', id]);
  }

  passwordMatchValidator(control: AbstractControl): ValidationErrors | null {
    const password = control.get('password');
    const confirm_password = control.get('confirm_password');

    if (password && confirm_password && password.value !== confirm_password.value) {
      return { 'passwordMismatch': true }; // Return error if passwords don't match
    }

    return null; // Return null if passwords match or any control is missing
  }

  handleBlurChange() {
    const password = this.createmeetingform.get('password').value;
    const confirm_password = this.createmeetingform.get('confirm_password').value;
    
    if (password !== confirm_password) {
      this.password_wrong = true;
    } else {
      this.password_wrong = false;
    }
  }
  // onInputName(event: Event): void {
  //   const inputElement = event.target as HTMLInputElement;
  //   const value = inputElement.value;
  //   const allowedCharacters = /^[A-Za-z ]*$/;
  
  //   // Remove any disallowed characters
  //   if (!allowedCharacters.test(value)) {
  //     inputElement.value = value.replace(/[^A-Za-z ]/g, '');
  //   }
  // }
  onInputName(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    let value = inputElement.value;
  
    // Regex to allow only letters and single spaces between words
    const allowedPattern = /^[A-Za-z]+(?: [A-Za-z]+)*$/;
  
    // Replace any disallowed characters or multiple spaces
    if (!allowedPattern.test(value)) {
      // Remove any non-letter characters and replace multiple spaces with a single space
      value = value.replace(/[^A-Za-z ]/g, '').replace(/\s+/g, ' ');
    }
  
    // Update the input element's value
    inputElement.value = value.trim(); // Trim any leading or trailing spaces
  }
  
  // Method to ensure only numeric input is allowed
onInputNumber(event: any): void {
  const input = event.target.value;
  // Replace non-numeric characters with an empty string
  event.target.value = input.replace(/[^0-9]/g, '');
}

  postdata(
    angForm1: any //angForm1
  ) {
    let values = angForm1.value;
    values['image'] = this.uploadFiles;
    values['captcha']= this.recaptchaToken;
    this.spinner = true;
    this.spinnerService.show();
   
    this.ApiService.createMentor(values).subscribe((d: any) => {
      this.spinner = false;
      this.spinnerService.hide();
      setTimeout(function () {
        Swal.fire({
          icon: 'success',
          iconColor: '#015792',
          title: 'Your Registration is Successful..!',
          html: `
            <p>Login with your credentials(Refer: WhatsApp/Email)</p>
            <div style="display: flex; justify-content:center; margin-left:10px">
              <div style="margin-top: 15px;margin-right: 7px;padding-left: 25px;color: #015792;">Press</div>
              <button class="swal2-confirm swal2-styled" id="custom-ok-button" type="button" style="background-color: #015792;">Ok</button>
  
              <div style="margin-top: 15px; margin-left: 7px;color: #015792;">To Continue</div>`,
              showConfirmButton:false,
          focusConfirm: false,
          preConfirm: () => {
            // Redirect to the login page
            window.location.href = 'login';
          }
        });
      
        // Add click event listener to the custom Ok button
        document.getElementById('custom-ok-button').addEventListener('click', function() {
          // Trigger the preConfirm function to redirect to the login page
          Swal.clickConfirm();
        });
      }, 1000);
      
        // Add click event listener to the custom Ok button
    
      
    
    
    
      // setTimeout(function () {
      //   Swal.fire({
      //     icon: 'success',
      //     title: 'Your Registration is Successful..!',
      //    text:'Login with your credentials(Refer: WhatsApp/Email)',
      //     confirmButtonText: 'Okay',
      //     confirmButtonColor: '#015792', 
      //     iconColor: '#015792',
      //   }).then((result) => {
      //     if (result.isConfirmed) {
      //       // window.location.reload();
      //       window.location.href = 'login';
      //     }
      //   });

      //   // Assuming you want to redirect to 'login' whether the user confirms or not
      //   // If you want to redirect only on confirmation, you should move this inside the 'then' block
      //   // window.location.href = 'login';
      // }, 100);
    });
  }
  delete_CM(id: any) {
    if (confirm('Are you sure want to cancel this Mentor ?')) {
      this.ApiService.deleteMentor(id)
        .pipe()
        .subscribe(
          (data) => {
            window.location.reload();
            alert('Mentor has been Deleted!');
          },

          (error) => {
            console.log(error);
          }
        );
    }
  }

  radiobutton(option: any) {
    this.MeetingOptions = option;
  }

  CM_name: any;
  CM_last_name: any;
  CM_education: any;
  CM_branch: any;
  CM_area: any;
  CM_courses: any;
  CM_meeting_location: any;
  CM_date: any;
  CM_time: any;
  CM_description: any;
  CM_activity_type: any;
  CM_comments: any;
  CM_participants: any;
 // CM_constituency: any;

  CM_assigned_to: any;
  CM_status: any;
  CM_activity: any;
  CM_others: any;
  CM_district: any;
  CM_father_name: any;
  CM_DOB: any;
  CM_email: any;
  CM_number: any;
  CM_parent_number: any;
  CM_grade: any;
  CM_college_name: any;
  CM_subject: any;
  CM_image: any;

  editfield: boolean = false;
  buttonviewmeeting(a: any, editbutton: any) {
    if (editbutton == 'edit') {
      $('#card_title').html('Edit Mentor’s Details');
      this.editfield = true;
    } else {
      $('#card_title').html('MENTOR DETAILS');
      this.editfield = false;
    }
    this.CM_name = a.first_name;
    this.CM_last_name = a.last_name;
    this.CM_education = a.education;
    this.CM_email = a.email;
    this.CM_number = a.number;
    this.CM_area = a.area;
    this.CM_courses = a.courses;
    this.CM_district = a.district;
    //this.CM_constituency = a.constituency;
        this.activity = a.activity;

    this.CM_status = a.status;
    this.CM_branch = a.branch;
    this.CM_image = a.image;
    this.uploadFiles = a.image;
    this.CM_id = a.id;

    this.editformInitialize(false);

    this.editmeetingform.get('name').setValue(a.first_name);
    this.editmeetingform.get('last_name').setValue(a.last_name);
    this.editmeetingform.get('education').setValue(a.education);
    this.editmeetingform.get('email').setValue(a.email);
    this.editmeetingform.get('number').setValue(a.number);
    this.editmeetingform.get('branch').setValue(a.branch);
    this.editmeetingform.get('district').setValue(a.district);
    //this.editmeetingform.get('constituency').setValue(a.constituency);
    this.editmeetingform.get('area').setValue(a.area);
    this.editmeetingform.get('courses').setValue(a.courses);
    this.editmeetingform.get('status').setValue(a.status);
    this.editmeetingform.get('activity').setValue(a.activity);

    if (a.district !== null) {
      //this.CM_constituency = a.constituency;
      this.CM_district = a.district;

      this.district = a.district;
      this.editmeetingform.get('district').setValue(a.district);
      this.user_constituency = this.ApiService.all_constituency[a.district];
      //this.editmeetingform.get('constituency').setValue(a.constituency);
    }
  }

  editformInitialize(a) {
    this.editmeetingform = this.fb.group({
      name: ['', [Validators.required, Validators.pattern('[A-Za-z ]{1,32}')]],
      last_name: ['', Validators.required],
      education: ['', Validators.required],
     activity: ['', Validators.required],

      branch: ['', Validators.required],
      //constituency: ['', Validators.required],
      email: ['', Validators.required],
      number: ['', Validators.required],
      area: ['', Validators.required],
      courses: ['', Validators.required],
      district: ['', Validators.required],
      status: ['', Validators.required],
      image: ['', Validators.required],
    });
  }

  updatedata(updateform, id) {
    let values = updateform.value;
    values['image'] = this.uploadFiles;
    // this.spinner = true;
    this.ApiService.updateMentor(this.CM_id, values)
      .pipe()
      .subscribe(
        (data) => {
          this.spinnerService.hide();

          setTimeout(function () {
            Swal.fire({
              title: 'Mentor has been updated!',
              icon: 'success',
              confirmButtonText: 'Okay',
              confirmButtonColor: '#015792', 
              iconColor: '#015792', // Set the icon color here
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.reload();
              }
            });
          }, 100);
        },

        (error) => {
          console.log(error);
        }
      );
  }
  //reset form values in createform
  Formreset() {
    this.createmeetingform.reset();
    this.hidden = true;
    this.MeetingOptions = '';
    this.participantsptions = '';
  }
  footerdate=new Date().getFullYear();
  minEndDate: string;

  // getCurrentDate(): string {
  //   const today = new Date();
  //   // Format the date as 'YYYY-MM-DD', which is the format accepted by <input type="date">
  //   return today.toISOString().split('T')[0];
  // }

  // setMinEndDate(event: any) {
  //   const startDateValue = event.target.value;
  //   if (startDateValue) {
  //     const startDate = new Date(startDateValue);
  //     const today = new Date();
  //     startDate.setDate(startDate.getDate()); // Increment by one day
  //     this.minEndDate = startDate.toISOString().split('T')[0]; // Set minimum end date
  //   }
  // }
  hidePassword = true;
  togglePasswordVisibility(): void {
    this.hidePassword = !this.hidePassword;
  }
  hidepassword= true;
  togglePassword():void{
    this.hidepassword = !this.hidepassword;

  }
  getCurrentDate(): string {
    const today = new Date();
    today.setDate(today.getDate()+1);
  
    // Format the date as 'YYYY-MM-DD', which is the format accepted by <input type="date">
    return today.toISOString().split('T')[0];
  }
  getFutureDate(): string {
    // Get the selected Course Start Date value
    const startDateValue = this.createmeetingform.get('available_from_date').value;
    
    // Parse the selected Course Start Date value
    const startDate = new Date(startDateValue);
  
    // Increment the selected Course Start Date by one day
    startDate.setDate(startDate.getDate());
    
    // Format the date as 'YYYY-MM-DD', which is the format accepted by <input type="date">
    return startDate.toISOString().split('T')[0];
  }
  close() {
    this.createmeetingform.reset(); // Resets the form (if applicable)
    // Optionally, navigate back or close the modal
    this.router.navigate(['']); // Adjust the route as needed
    // window.location.reload();
}
isFormDisabled(): boolean {
   
    return !this.createmeetingform.valid || (this.test_email ==='true') || (this.test_ph ==='true')|| !this.captchaResolved;

  }

  
passwordValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const password = control.value;
    
    if (!password) {
      return null; // Return null if there's no input yet
    }

    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
    const hasMinLength = password.length >= 8;

    const passwordValid = hasUpperCase && hasLowerCase && hasSpecialChar && hasMinLength;

    return !passwordValid ? { passwordStrength: true } : null;
  };
}
onKeyPressName(event: KeyboardEvent): void {
  const key = event.key;
  const allowedCharacters = /^[A-Za-z ]$/;
  
  if (!allowedCharacters.test(key)) {
    event.preventDefault(); // Prevents the character from being typed
  }
}
onKeyPressCourse(event: KeyboardEvent): void {
  const key = event.key;
  const allowedCharacters = /^[A-Za-z ,.'-]$/;

  if (!allowedCharacters.test(key)) {
    event.preventDefault(); // Prevents the character from being typed
  }
}
onKeyPressNumber(event: KeyboardEvent): void {
  const key = event.key;
  const allowedCharacters = /^[0-9]$/;

  // Get the current value and check the length
  const input = (event.target as HTMLInputElement).value;

  // Allow only numbers and limit to 15 characters for Non-Resident, or 10 digits for Resident
  if (!allowedCharacters.test(key) || (this.available && input.length >= 15 && key !== 'Backspace') || (!this.available && input.length >= 10 && key !== 'Backspace')) {
    event.preventDefault(); // Prevents the character from being typed
  }
}

onKeyPressCountryCode(event: KeyboardEvent) {
  const allowedChars = /^[\+\d]$/;
  if (!allowedChars.test(event.key)) {
      event.preventDefault();
  }
}


}
